module.exports = __webpack_public_path__ + "static/media/bowen-59.634a6af8.jpg";